import { JornadaLaboral, ResponseRequest, ResponseRequestGeneric, WrapperResponse } from 'components/Types/GeneralTypes';
import { alertService } from 'components/Varios/alert_service'
import Cargando from 'components/Varios/Cargando';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import PDFViewer from 'components/Varios/PDFViewer';
import { isWeekday, isFeriadoFilter, isFeriado, } from 'functions/CalendarFunctions';
import { ObtenerFechaFromIsoFormat, SumarDiasFecha, SumarMesesFecha, ParseHorasFormato, AgregarHoraAFecha, ObtenerFechaLaboralDeSuma } from 'functions/DatesFunctions';
import { DownloadDocument } from 'helpers/files';
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Table, Card, CardHeader, CardBody, CardFooter, CardLink, CardText, FormGroup, Label, Input } from "reactstrap"
import { Col, Row } from 'react-bootstrap'
import { authenticationService } from 'services/authentication.service';
import { HorarioLaboralServidor, InformacionDetalleES, InformacionGeneral, ModalDetalleES, RegistroEntradaSalida, ModalJustificacionES, TablaDetalleES } from 'components/UsuarioGeneral/Registro Entrada Salida/typesRegistroEntradaSalida';
import axios from "axios"
import { UserData } from "components/Sidebar/Sidebar_Principal";
import configData from "config.json"
import { authHeaderWithToken } from "helpers/auth-header";
import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew'
import add from 'date-fns/add'
import "../../../assets/scss/RegistroEntradaSalidaAlmuerzo.scss"
import Datepicker from 'components/Varios/Datepicker';
import TimePickerComponent from 'components/Varios/TimePicker/CustomTimePicker';
import TdSeeMoreContent from 'components/Varios/Tabla/TdSeeMoreContent';
import { SELECT_FIN_RECESO, SELECT_INICIO_FIN_LABORAL, SELECT_INICIO_FIN_RECESO, SELECT_INICIO_RECESO, ValidarMensajeExpiracionProxima, ValidarMensajeSolicitudExpirada, ValidarMensajeSolicitudRecuperacionNoEjecutada, ValidarMensajeSolicitudRecuperacionNoEjecutadaVencida } from 'components/DirectivoUnidad/RegistroEntradaSalida/RegistroEntradaSalida';
import BotonMarcacionEntradaSalida, { TipoJornadaBotonMarcacion, TipoSituacionBotonMarcacion } from './BotonMarcacionEntradaSalida';

import COMUNICADOMARCACION from "../../../assets/img/ComunicadoMarcacionTH.jpg"
import { CerrarLocalStorageMensajeMarcacion, CreateLocalStorageMensajeMarcacion, KEY_SHOWMODAL_MARCACION_AVISO, VerifyShowMensajeMarcacionStorage } from 'functions/LocalStorageFunctions';
import { HorarioLaboralServidorPermisosHoras } from '../Vacaciones/Solicitud Vacaciones/TypesSolicitudVacaciones';
import { ObtenerHorarioLaboralEnFecha } from '../Vacaciones/Solicitud Vacaciones/FunctionsSolicitudVacaciones';
import { Link } from 'react-router-dom';
import { ROUTE_HISTORIAL_MARCACIONES } from 'Context/SideBarContext';
import { showAlert, showAlertAviso } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';


export const OPCIONES_SELECT_MARCACION = ["Inicio del receso/almuerzo", "Fin del receso/almuerzo", "Inicio y fin del receso/almuerzo"];
export const OPCIONES_SELECT_MOTIVO = ["Descuido personal", "Distracción", "Olvido", "Omisión involuntaria"];
export const TIEMPO_MIN_ALMUERZO = 25;
export const TIEMPO_MAX_ALMUERZO = 30;
export const MENSAJE_ADVERTENCIA_LAPSO_SOLICITUD = "Usted tiene hasta un máximo de 2(dos) días para solicitar la justificación de no marcación y/o recuperación de tiempo no laborado.Recuerde que las solicitudes de recuperación de tiempo no laborado deben estar autorizadas por su Directivo, previo a la fecha de recuperación.";




export const ESTADO_REGISTRO_JUSTIFICADO = "Justificado";

export const ESTADO_EXCESO_RECESO = "Jornada Excedida Receso";
export const ESTADO_JORNADA_INCUMPLIDA = "Jornada Incompleta de Labores"
export const ESTADO_AUSENCIA_LABORES = "Ausencia de Marcación Labores";
export const ESTADO_AUSENCIA_RECESO = "Ausencia de Marcación Receso";
export const ESTADO_REGISTRO_INCOMPLETO = "Registro incompleto";
export const ESTADO_JORNADA_COMPLETA_RECESO = "Jornada Completa de receso";
export const ESTADO_JORNADA_COMPLETA_LABORES = "Jornada Completa de labores";

export const ESTADO_JORNADA_INCUMPLIDA_MARCACION_DEL_DIA = "J. Incompleta Labores (sujeta a revisión de permisos, licencias, comisiones, vacaciones, justific y recuperac)"


export const ESTADOS_CON_NOVEDAD = [ESTADO_EXCESO_RECESO, ESTADO_JORNADA_INCUMPLIDA, ESTADO_AUSENCIA_LABORES, ESTADO_AUSENCIA_RECESO, ESTADO_REGISTRO_INCOMPLETO, ESTADO_JORNADA_INCUMPLIDA_MARCACION_DEL_DIA]


export default function RegistroEntradaSalidaAlmuerzo() {
    const defaultState: RegistroEntradaSalida = {
        idpersona: 0,
        tipomarcada: "",
        tipojornada: "",
        entradal: "",
        salidal: "",
        entradaa: "",
        salidaa: "",
        duracionl: "",
        duraciona: "",
        fecha: "",
        fechar: "",
        estadol: "",
        estadoa: "",
        ip: "",
        justificaciontipo: "",
        justificacionmotivo: "",
    }
    const defaultStateH: HorarioLaboralServidor = {
        puedemarcarl: "N",
        puedemarcarlE: "N",
        puedemarcarlS: "N",
        puedemarcara: "N",
        puedemarcaraE: "N",
        puedemarcaraS: "N",
        nocturno: "N",
        horaentradal: "",
        horasalidal: "",
        horaentradaa: "",
        horamaximaentradaa: "",
        horasalidaa: "",
        mensaje: "",
        fechahora: (new Date().getTime()).toString(),
        fecha: "",
    }
    const defaultStateI: InformacionGeneral = {
        marcacion_dia: defaultState,
        //lista_registro: [],
        marcacion_horario: defaultStateH,
        //feriados: [],
        // ultimodiames: 0
    }
    const defaultStateModalDetalleES: ModalDetalleES = {
        loadingInformacion: false,
        tabladetalle: undefined,
        fecha: ""
    }
    const defaultStateModalJusticicacionES: ModalJustificacionES = {
        loadingInformacion: false,
        tabladetalle: undefined,
        fecha: "",
        entrada: "",
        salida: "",
        tipo: "",
        exceso: "",
        url: "",
        tipojornada: "A"
    }

    const [loading, setloading] = useState<boolean>(false)
    const [loadingDatos, setloadingDatos] = useState<boolean>(false)
    const [datosMarcacion, setdatosMarcacion] = useState<InformacionGeneral>(defaultStateI)
    const [stateModalDetalleES, setstateModalDetalleES] = useState<ModalDetalleES>(defaultStateModalDetalleES)
    const [stateModalJustificacionES, setstateModalJustificacionES] = useState<ModalJustificacionES>(defaultStateModalJusticicacionES)
    var [date, setDate] = useState(new Date())
    const [Ip, setIp] = useState<string>("")
    const [selectMarcacion, setselectMarcacion] = useState<string>("def")
    const [selectMotivo, setselectMotivo] = useState<string>("def")
    const [horaDesde, setHoraDesde] = useState<string>("")
    const [horaHasta, setHoraHasta] = useState<string | null>("")
    const [errorHoras, seterrorHoras] = useState<string>("")
    const [horaDesdeR, setHoraDesdeR] = useState<string>("")
    const [horaHastaR, setHoraHastaR] = useState<string>("")
    const [habilitarIngresoHoras, sethabilitarIngresoHoras] = useState<boolean>(false)
    const [fechaPermisoHora, setfechaPermisoHora] = useState<Date | null>(null)
    const [mostrarModalMarcacion, setmostrarModalMarcacion] = useState<boolean>(false)
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const [jornadas, setJornadas] = useState<JornadaLaboral[]>([]);
    const [horarioParaPermisoHora, sethorarioParaPermisoHora] = useState<HorarioLaboralServidorPermisosHoras | undefined>(undefined)
    const [excesoMarcacion, setexcesoMarcacion] = useState<string>("")
    const [loadingHorarioPermisoHora, setloadingHorarioPermisoHora] = useState<boolean>(false)
    function handleError() {
    }
    function handleErrorInformacion() {
        alertService.error("Ha ocurrido un inconveniente");
    }

    async function getIp() {
        const response = await axios.get("https://api.ipify.org/?format=json")
        setIp(response.data.ip)
    }

    async function CrearRegistroMarcacionS(_tipomarcada_) {
        var resultado: ResponseRequest = { status: 200 };

        var userData: UserData = authenticationService.currentUserValue;

        const marcacion: RegistroEntradaSalida = {
            idpersona: userData.idpersona,
            tipomarcada: _tipomarcada_,
            tipojornada: "A",
            entradal: "",
            salidal: "",
            entradaa: "",
            salidaa: "",
            duracionl: "",
            duraciona: "",
            fecha: "",
            fechar: "",
            estadol: "",
            estadoa: "",
            ip: Ip,
            justificaciontipo: "",
            justificacionmotivo: ""
        }

        const URL = `${configData.SERVER_URL}RegistroEntradaSalida/PostGuardarMarcaciones`;
        try {

            const respuesta = await axios.post(URL, marcacion, {
                headers: authHeaderWithToken(userData.token)
            })

            resultado = { status: respuesta.status, dataResponse: respuesta.data }
        } catch (error) {
            var mensaje: string = "Ha ocurrido un inconveniente";
            if (axios.isAxiosError(error) && error.response) {
            }
        }
        return resultado;
    }

    const HandleClickRegistrarMarcacionE = useCallback(async () => {

        if (loading) {
            return;
        }

        setloading(true)
        const resultado: ResponseRequest = await CrearRegistroMarcacionS("E");
        if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "S") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,true)
        }
        else if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "N") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje, false)
        }
        else {
            showAlert(resultado.errorMessage??"",false);
        }
        setloading(false)
    }, [loading])


    const HandleClickRegistrarMarcacionS = useCallback(async () => {
        if (loading) {
            return
        }

        setloading(true)
        setmostrarModalMarcacion(true)
        const resultado: ResponseRequest = await CrearRegistroMarcacionS("S");
        if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "S") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje,true)
        }
        else if (resultado.status === 200 && resultado.dataResponse && resultado.dataResponse.strEstado === "N") {
            GetInfoMarcacion();
            showAlert(resultado.dataResponse.strMensaje, false)
        }
        else {
            showAlert(resultado.errorMessage??"",false);
        }
        setloading(false)
    }, [loading])

    const BotonGenerarRegistrarMarcacionE = useMemo(() => {
        if (datosMarcacion.marcacion_horario.puedemarcara == "S" && !datosMarcacion.marcacion_dia?.entradaa && !datosMarcacion.marcacion_dia?.salidaa)
            //if (date.getTime() > new Date().setHours(Number(datosMarcacion.marcacion_horario.horaentradaa.split(":")[0]), 0, 0) && date.getTime() <= new Date().setHours(Number(datosMarcacion.marcacion_horario.horasalidaa.split(":")[0]) - 1, 30, 0)) {
            //return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={loading} onClick={() => HandleClickRegistrarMarcacionE()}>Marcar inicio</Button>)
            if (datosMarcacion.marcacion_horario.puedemarcaraE === "S") {
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={loading}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                        onClickButton={() => HandleClickRegistrarMarcacionE()}
                        className={"twoButtosMarcacion"}
                    />
                )
            }

            else {
                //return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio</Button>)
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={true}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                        className={"twoButtosMarcacion"}
                    />
                )
            }

        else if (datosMarcacion.marcacion_horario.puedemarcara == "N") {
            return (datosMarcacion.marcacion_horario.mensaje)
        }

        else {
            //return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar inicio</Button>)
            return (
                <BotonMarcacionEntradaSalida
                    disabled={true}
                    tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                    tipoSituacion={TipoSituacionBotonMarcacion.ENTRADA}
                    className={"twoButtosMarcacion"}
                />
            )
        }

    }, [loading, datosMarcacion]);

    const BotonGenerarRegistrarMarcacionS = useMemo(() => {
        if (datosMarcacion.marcacion_horario.puedemarcara == "S" && datosMarcacion.marcacion_dia?.entradaa && !datosMarcacion.marcacion_dia?.salidaa) {

            if (datosMarcacion.marcacion_horario.puedemarcaraS === "S") {
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={loading}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                        onClickButton={() => HandleClickRegistrarMarcacionS()}
                        className={"twoButtosMarcacion"}
                    />
                )
            }
            else {
                return (
                    <BotonMarcacionEntradaSalida
                        disabled={true}
                        tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                        tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                        className={"twoButtosMarcacion"}
                    />
                )

            }

        }
        else if (datosMarcacion.marcacion_horario.puedemarcara == "N")
            return ("")
        else {
            //return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled>Marcar fin</Button>)
            return (
                <BotonMarcacionEntradaSalida
                    disabled={true}
                    tipoJornada={TipoJornadaBotonMarcacion.ALMUERZO}
                    tipoSituacion={TipoSituacionBotonMarcacion.SALIDA}
                    className={"twoButtosMarcacion"}
                />
            )
        }

    }, [loading, datosMarcacion]);

    async function obtenerDetalleES(fecha: string) {
        const infoUsuario: UserData = authenticationService.currentUserValue;

        var respuestaResponse: ResponseRequest = { status: -1 }
        const URL = configData.SERVER_URL + "RegistroEntradaSalida/DetalleES/" + fecha
        try {
            const respuesta = await axios.get(URL, {
                headers: authHeaderWithToken(infoUsuario.token)
            })

            const dataResponse: InformacionDetalleES = respuesta.data;

            respuestaResponse = {
                status: respuesta.status,
                dataResponse
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                respuestaResponse = { status: error.response.status }
            }
        }

        return respuestaResponse;
    }

    async function Justificacion(_tipomarcada_) {
        var resultado: ResponseRequest = { status: 200 };

        var userData: UserData = authenticationService.currentUserValue;

        var fecha_;
        if (_tipomarcada_ === "E")
            fecha_ = fechaPermisoHora;
        else
            fecha_ = stateModalJustificacionES.fecha;

        const marcacion: RegistroEntradaSalida = {
            idpersona: userData.idpersona,
            tipomarcada: _tipomarcada_,
            tipojornada: "A",
            entradal: "",
            salidal: "",
            entradaa: horaDesde,
            salidaa: horaHasta,
            duracionl: "",
            duraciona: "",
            fecha: fecha_,
            fechar: stateModalJustificacionES.fecha,
            estadol: "",
            estadoa: "",
            ip: Ip,
            justificaciontipo: selectMarcacion,
            justificacionmotivo: selectMotivo,
        }

        const URL = `${configData.SERVER_URL}RegistroEntradaSalida/PostGuardarJustificacion`;
        try {
            const respuesta = await axios.post(URL, marcacion, {
                headers: authHeaderWithToken(userData.token)
            })

            resultado = { status: respuesta.status, dataResponse: respuesta.data }
        } catch (error) {
            var mensaje: string = "Ha ocurrido un inconveniente";
            if (axios.isAxiosError(error) && error.response) {

            }

            const wra: WrapperResponse<TablaDetalleES> = {
                entidad: null,
                strEstado: "N",
                strMensaje: mensaje
            }


            resultado = {
                status: 200,
                dataResponse: wra,
                errorMessage: mensaje
            }
        }
        return resultado;
    }

    async function GetVistaPreviaFormularioJustificacion(_tipomarcada_) {
        var resultado: ResponseRequestGeneric<string> = { status: 200, dataResponse: "" };

        var userData: UserData = authenticationService.currentUserValue;

        var fecha_;
        if (_tipomarcada_ === "E")
            fecha_ = fechaPermisoHora;
        else
            fecha_ = stateModalJustificacionES.fecha;

        const marcacion: RegistroEntradaSalida = {
            idpersona: userData.idpersona,
            tipomarcada: _tipomarcada_,
            tipojornada: "A",
            entradal: "",
            salidal: "",
            entradaa: horaDesde,
            salidaa: horaHasta,
            duracionl: "",
            duraciona: "",
            fecha: fecha_,
            fechar: stateModalJustificacionES.fecha,
            estadol: "",
            estadoa: "",
            ip: Ip,
            justificaciontipo: selectMarcacion,
            justificacionmotivo: selectMotivo,
        }

        var URL = `${configData.SERVER_URL}RegistroEntradaSalida/VistaPreviaFormularioIngresoJustificacion`;

        if (_tipomarcada_ === "E") {
            var URL = `${configData.SERVER_URL}RegistroEntradaSalida/VistaPreviaFormularioIngresoRecuperacion`;
        }

        try {
            const respuesta = await axios.post(URL, marcacion,
                {
                    headers: authHeaderWithToken(userData.token),
                    responseType: "blob"
                }
            )

            const blob_resource = await respuesta.data;
            const url_documento = window.URL.createObjectURL(blob_resource);
            resultado = { status: respuesta.status, dataResponse: url_documento }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

                resultado = { status: error.response.status, errorMessage: mensaje }
            }
            else if (axios.isAxiosError(error) && !error.response) {
                resultado = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
            }
        }
        return resultado;
    }

    async function HandleClickBotonJustificacion() {
        setloading(true)

        const resultado: ResponseRequest = await Justificacion(stateModalJustificacionES.tipo);
        if (resultado.status === 200) {
            if (resultado.dataResponse.strEstado === "N") {
                ReiniciarJustificacionES();
                alertService.error(resultado.dataResponse.strMensaje);
            }
            else {
                ReiniciarJustificacionES();
                alertService.success(resultado.dataResponse.strMensaje);
            }
            GetInfoMarcacion();
            verDetalleES(datosMarcacion.marcacion_horario.fecha);
        }
        else {
            alertService.error(resultado.errorMessage);
            //Esto cierra el modal de justificaciones
            setstateModalJustificacionES(defaultStateModalJusticicacionES)
            //Se trata de cerrar el modal de detalles tambien
            setstateModalDetalleES(defaultStateModalDetalleES)
        }

        setloading(false)
    }

    const HandleClickBotonVistaPreviaSolicitudJustificacion = useCallback(
        async () => {
            setloading(true)

            const resultado: ResponseRequestGeneric<string> = await GetVistaPreviaFormularioJustificacion(stateModalJustificacionES.tipo);
            if (resultado.status === 200 && resultado.dataResponse !== undefined) {
                //GetInfoMarcacion();

                const copiaState: ModalJustificacionES = { ...stateModalJustificacionES, url: resultado.dataResponse }

                setstateModalJustificacionES(copiaState);
            }
            else {
                alertService.error(resultado.errorMessage);
                //Esto cierra el modal de justificaciones
                setstateModalJustificacionES(defaultStateModalJusticicacionES)
                //Se trata de cerrar el modal de detalles tambien
                setstateModalDetalleES(defaultStateModalDetalleES)
            }
            setloading(false)
        },
        [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras],
    )

    const HandleClickBotonVistaPreviaSolicitudJustificacionRecuperacion = useCallback(
        async () => {
            setloading(true)

            const resultado: ResponseRequestGeneric<string> = await GetVistaPreviaFormularioJustificacion(stateModalJustificacionES.tipo);
            if (resultado.status === 200 && resultado.dataResponse !== undefined) {
                //GetInfoMarcacion();

                const copiaState: ModalJustificacionES = { ...stateModalJustificacionES, url: resultado.dataResponse }

                setstateModalJustificacionES(copiaState);
            }
            else {
                alertService.error(resultado.errorMessage);
                setstateModalJustificacionES(defaultStateModalJusticicacionES)
                //Se trata de cerrar el modal de detalles tambien
                setstateModalDetalleES(defaultStateModalDetalleES)
            }
            setloading(false)
        },
        [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, fechaPermisoHora, horaDesde, horaHasta, errorHoras]);

    const BotonJustificacionExceso = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || fechaPermisoHora == null || horaDesde === "" || horaHasta === "" || selectMotivo === "def" || loading;
        return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonJustificacion()}>Aceptar</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, fechaPermisoHora, horaDesde, horaHasta, errorHoras]);

    const BotonVistaPreviaFormularioRecuperacion = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || fechaPermisoHora == null || horaDesde === "" || horaHasta === "" || selectMotivo === "def" || loading;
        return (<Button className="secondary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonVistaPreviaSolicitudJustificacionRecuperacion()}>Vista Previa Solicitud</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, fechaPermisoHora, horaDesde, horaHasta, errorHoras]);

    const BotonVistaPreviaFormularioJustificacion = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || selectMotivo === "def" || selectMarcacion === "def" || horaDesde === "" || horaHasta === "" || loading;
        return (<Button className="secondary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonVistaPreviaSolicitudJustificacion()}>Vista Previa Solicitud</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras]);

    const BotonJustificacionAusencia = useMemo(() => {
        const deshabilitarBoton = errorHoras !== "" || selectMotivo === "def" || selectMarcacion === "def" || horaDesde === "" || horaHasta === "" || loading;
        return (<Button className="primary" type="button" style={{ float: 'inherit' }} disabled={deshabilitarBoton} onClick={() => HandleClickBotonJustificacion()}>Aceptar</Button>)
    }, [loading, datosMarcacion, stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras]);

    // const DatePickerFechaHora = useCallback(() => {

    //     const fechaActualConTime = new Date();
    //     const fechaActual = new Date(fechaActualConTime.getFullYear(), fechaActualConTime.getMonth(), fechaActualConTime.getDate(), 0, 0, 0);
    //     //const fechaActual = new Date(2024, 4,30 );


    //     const feriados = datosMarcacion.feriados.map((val, ind) => {
    //         return new Date(val)
    //     })
    //     var excludeDates = [...feriados];

    //     var fechaminima = SumarDiasFecha(fechaActual, 1);



    //     const ultimaFechaDelMes = SumarDiasFecha(fechaActual, (datosMarcacion.ultimodiames - fechaActual.getDate()));

    //     var fechaMaxima = ultimaFechaDelMes

    //     if (stateModalJustificacionES.tipo === "E") {


    //         const FechaCon2DiasDespues = ObtenerFechaLaboralDeSuma(fechaActual, 2, feriados);

    //         if (FechaCon2DiasDespues.getTime() > ultimaFechaDelMes.getTime()) {
    //             fechaMaxima = ObtenerFechaLaboralDeSuma(fechaActual, 2, feriados);
    //         }


    //     }




    //     return (
    //         <Datepicker
    //             value={fechaPermisoHora}
    //             name="fechaPermisoHora"
    //             id="fechaPermisoHora"
    //             onChange={(e) => setfechaPermisoHora(e)}
    //             min={fechaminima}
    //             max={fechaMaxima}
    //             filter={(datefilter: Date) => isWeekday(datefilter) && isFeriadoFilter(datefilter, feriados)}
    //             showDisabledMonthNavigation={true}
    //             excludeDates={excludeDates}
    //             dayClassName={(datefilter: Date) => isFeriado(datefilter, feriados)}
    //         />
    //     )
    // }, [fechaPermisoHora, datosMarcacion, stateModalJustificacionES])


    const OnChangeHoraDesde = useCallback(
        (e: any) => {
            setHoraDesde(e.format('HH:mm'));

            if (selectMarcacion === SELECT_INICIO_FIN_LABORAL || selectMarcacion === SELECT_INICIO_FIN_RECESO) {
                setHoraHasta(null);
            }

        },
        [selectMarcacion],
    )



    const inputHoraDesde = useCallback(
        (isdisabled?: boolean) => {
            return (
                // <Input type="time" className="inputTime" value={horaDesde} onChange={(e) => OnChangeHoraDesde(e)} />

                <TimePickerComponent
                    value={horaDesde === "" ? null : horaDesde}
                    onChange={(e) => OnChangeHoraDesde(e)}
                    disabled={(isdisabled !== undefined && isdisabled === true)}

                />
            )
        },
        [horaDesde]
    )


    function onChangeHoraHasta(value: any) {
        setHoraHasta(value);
    }

    const inputHoraHasta = useCallback(
        (isdisabled?: boolean) => {
            return (
                <>
                    {/* <Input disabled={horaDesde === ""} type="time" className="inputTime" min={"12:00"} max={"15:30"} value={horaHasta} onChange={(e) => onChangeHoraHasta(e.target.value)} /> */}

                    <TimePickerComponent
                        value={horaHasta === "" ? null : horaHasta}
                        onChange={(e) => setHoraHasta(e.format('HH:mm'))}
                        disabled={horaDesde === "" || horaDesde === null || (isdisabled !== undefined && isdisabled === true)}

                    />
                </>
            )
        },
        [horaDesde, horaHasta, errorHoras]
    )


    useEffect(() => {
        if (fechaPermisoHora !== null) {

            const VerificarHorarioLaboralEnFecha = async () => {
                setloadingHorarioPermisoHora(true)
                const respuesta = await ObtenerHorarioLaboralEnFecha(fechaPermisoHora);
                if (respuesta.status === 200 && respuesta.dataResponse) {
                    sethorarioParaPermisoHora(respuesta.dataResponse)

                }
                setloadingHorarioPermisoHora(false)
            }

            VerificarHorarioLaboralEnFecha();
        }
    }, [fechaPermisoHora])


    useEffect(() => {
        if (horarioParaPermisoHora && excesoMarcacion !== "" && fechaPermisoHora) {

            var tiempoAlmuerzo = excesoMarcacion.split(':');
            var tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);
            var [hora_desde, minuto_desde] = horarioParaPermisoHora.horaSalida.split(":");

            const fechaEscogida = new Date(fechaPermisoHora);
            fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +tiempoAlmuerzoMinutos, 0);
            var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();

            setHoraDesde(horarioParaPermisoHora.horaSalida)
            setHoraHasta(horahasta);
        }
    }, [horarioParaPermisoHora, excesoMarcacion, fechaPermisoHora])





    useEffect(() => {
        if ((horaDesde !== "") && (horaHasta !== "") && horaHasta !== null && stateModalJustificacionES.tipo === "A") {
            const fechaEscogida = new Date();

            const [hora_inicio_almuerzo, minuto_inicio_almuerzo] = datosMarcacion.marcacion_horario.horaentradaa.split(":");
            const [hora_maxima_inicio_almuerzo, minuto_maxima_inicio_almuerzo] = datosMarcacion.marcacion_horario.horamaximaentradaa.split(":");

            const [hora_fin_almuerzo, minuto_fin_almuerzo] = datosMarcacion.marcacion_horario.horasalidaa.split(":");
            const [hora_desde_seleccionada, minuto_desde] = horaDesde.split(":");
            const [hora_hasta_seleccionada, minuto_hasta] = horaHasta.split(":");

            const horaInicioAlmuerzo = add(fechaEscogida, { hours: +hora_inicio_almuerzo, minutes: +minuto_inicio_almuerzo });
            const horaMaximaInicioAlmuerzo = add(fechaEscogida, { hours: +hora_maxima_inicio_almuerzo, minutes: +minuto_maxima_inicio_almuerzo });

            const horaFinAlmuerzo = add(fechaEscogida, { hours: +hora_fin_almuerzo, minutes: +minuto_fin_almuerzo });
            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });




            if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                seterrorHoras("La hora hasta no puede ser menor a la hora desde");
            }
            else if (horaDesdeSeleccionada.getTime() < horaInicioAlmuerzo.getTime()) {
                seterrorHoras("La hora desde debe ser despues de las " + datosMarcacion.marcacion_horario.horaentradaa + " horas");
            }
            else if (horaDesdeSeleccionada.getTime() > horaMaximaInicioAlmuerzo.getTime()) {
                seterrorHoras("La hora desde no puede ser mayor a las " + datosMarcacion.marcacion_horario.horamaximaentradaa + " horas");
            }
            else {
                var diff = (horaHastaSeleccionada.getTime() - horaDesdeSeleccionada.getTime()) / 1000;
                diff /= 60;
                if (Math.abs(Math.round(diff)) > TIEMPO_MAX_ALMUERZO)
                    seterrorHoras("La duración del receso/almuerzo es de 30 minutos");
                else if (Math.abs(Math.round(diff)) < TIEMPO_MAX_ALMUERZO)
                    seterrorHoras("La duración del receso/almuerzo es de 30 minutos");
                //else if (Math.abs(Math.round(diff)) < TIEMPO_MIN_ALMUERZO)
                //seterrorHoras("La duración del receso/almuerzo no puede ser menor a 25 minutos");
                else
                    seterrorHoras("");
            }
        }
        else if ((horaDesde !== "") && (horaHasta !== "") && horaHasta !== null && stateModalJustificacionES.tipo === "E") {
            const fechaEscogida = new Date();

            const [hora_salida_labroal, minuto_salida_laboral] = datosMarcacion.marcacion_horario.horasalidal.split(":");
            const hora_desde_seleccionada = horaDesde.split(":")[0];
            const minuto_desde = horaDesde.split(":")[1];
            const hora_hasta_seleccionada = horaHasta.split(":")[0];
            const minuto_hasta = horaHasta.split(":")[1];

            const tiempoAlmuerzo = stateModalJustificacionES.exceso.split(':');
            const tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);

            const horaSalidaLaboral = add(fechaEscogida, { hours: +hora_salida_labroal, minutes: +minuto_salida_laboral });
            const horaDesdeSeleccionada = add(fechaEscogida, { hours: +hora_desde_seleccionada, minutes: +minuto_desde });
            const horaHastaSeleccionada = add(fechaEscogida, { hours: +hora_hasta_seleccionada, minutes: +minuto_hasta });

            if (horaHastaSeleccionada.getTime() < horaDesdeSeleccionada.getTime()) {
                seterrorHoras("La hora hasta no puede ser menor a la hora desde");
            }
            else if (horaDesdeSeleccionada.getTime() < horaSalidaLaboral.getTime()) {
                seterrorHoras("Solo puede recuperar después de la jornada laboral");
            }
            else {
                var diff = (horaHastaSeleccionada.getTime() - horaDesdeSeleccionada.getTime()) / 1000;
                diff /= 60;
                if (Math.abs(Math.round(diff)) !== tiempoAlmuerzoMinutos)
                    seterrorHoras("La recuperación del tiempo debe ser de " + tiempoAlmuerzoMinutos + " minutos");
                else
                    seterrorHoras("");
            }
        }
    }, [stateModalJustificacionES, horaDesde, horaHasta, errorHoras, datosMarcacion, horarioParaPermisoHora])

    const contenidoModalJustificacionES: any = useMemo(() => {
        if (stateModalJustificacionES.loadingInformacion) {
            return <Cargando />
        }
        else if (stateModalJustificacionES.fecha !== "" && stateModalJustificacionES.fecha.length === 0) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle</p>
                </>
            )
        }
        else if (stateModalJustificacionES.fecha !== "" && stateModalJustificacionES.loadingInformacion === false && stateModalJustificacionES.tipo === "E") {
            const tabla =

                <>
                    <div className="content">

                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>
                                        Jornada de trabajo que solicita recuperar:
                                    </span>
                                    <p> <i className="fa-regular fa-calendar"></i> {stateModalJustificacionES.fecha} - {stateModalJustificacionES.exceso}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                Fecha y hora que solicita recuperar:
                            </Col>
                            <Col md={3}>
                                <FormGroup>
                                    <Label for="fechaHoraSolicitud">
                                        Fecha
                                    </Label>
                                    {/* {DatePickerFechaHora()} */}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horadesdeSolicitud">
                                        Hora Desde
                                    </Label>
                                    {inputHoraDesde(true)}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horahastaSolicitud">
                                        Hora Hasta
                                    </Label>
                                    {inputHoraHasta(true)}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>Motivo por el cual solicita la recuperación:</span>
                                    <Input
                                        type="select"
                                        id="motivomarcacion"
                                        name="motivomarcacion"
                                        value={selectMotivo}
                                        onChange={(e) => setselectMotivo(e.target.value)}
                                        defaultValue={"def"}
                                    >
                                        <option value={"def"}>Seleccione</option>
                                        {
                                            OPCIONES_SELECT_MOTIVO.map((opcion, indiceOpcion) => {
                                                return (
                                                    <option key={"motivomarcacion" + indiceOpcion} value={opcion}>{opcion}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="rowErroresHoras">
                            <Col xs={12}>
                                <small className='small-error'>{errorHoras}</small>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {BotonVistaPreviaFormularioRecuperacion}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12}> {BotonJustificacionExceso} </Col>
                        </Row>
                        {
                            loading &&
                            <Cargando />
                        }
                        {
                            stateModalJustificacionES.url &&
                            <Row>
                                <Col>
                                    <PDFViewer url={stateModalJustificacionES.url} heightValue={"100%"} />

                                </Col>
                            </Row>
                        }
                    </div>

                </>

            return tabla;
        }
        else if (stateModalJustificacionES.fecha !== "" && stateModalJustificacionES.loadingInformacion === false && stateModalJustificacionES.tipo === "A") {

            const disabledHoraDesde: boolean = selectMarcacion === SELECT_FIN_RECESO
            const disabledHoraHasta: boolean = selectMarcacion === SELECT_INICIO_RECESO

            const tabla =

                <>
                    <div className="content">
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>
                                        Jornada de trabajo que solicita justificar:
                                    </span>
                                    <p> <i className="fa-regular fa-calendar"></i> {stateModalJustificacionES.fecha}</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>Correspondiente a la marcación de:</span>
                                    <Input
                                        type="select"
                                        id="selectmarcacion"
                                        name="selectmarcacion"
                                        value={selectMarcacion}
                                        disabled
                                        onChange={(e) => setselectMarcacion(e.target.value)}
                                    >
                                        <option value={"def"}>Seleccione</option>
                                        {
                                            OPCIONES_SELECT_MARCACION.map((opcion, indiceOpcion) => {
                                                return (
                                                    <option key={"selectmarcacion" + indiceOpcion} value={opcion}>{opcion}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                Horas que solicita se registre como marcación
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horadesdeSolicitud">
                                        Hora Desde
                                    </Label>
                                    {inputHoraDesde(selectMarcacion === SELECT_FIN_RECESO)}
                                    {/* <Input type="time" className="inputTime" value={horaDesde} onChange={(e) => setHoraDesde(e.target.value)} /> */}
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup>
                                    <Label for="horahastaSolicitud">
                                        Hora Hasta
                                    </Label>
                                    {inputHoraHasta(selectMarcacion === SELECT_INICIO_RECESO)}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="rowErroresHoras">
                            <Col xs={12}>
                                <small className='small-error'>{errorHoras}</small>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <span>Motivo por el cual no registró la marcación requerida:</span>
                                    <Input
                                        type="select"
                                        id="motivomarcacion"
                                        name="motivomarcacion"
                                        value={selectMotivo}
                                        onChange={(e) => setselectMotivo(e.target.value)}
                                        defaultValue={"def"}
                                    >
                                        <option value={"def"}>Seleccione</option>
                                        {
                                            OPCIONES_SELECT_MOTIVO.map((opcion, indiceOpcion) => {
                                                return (
                                                    <option key={"motivomarcacion" + indiceOpcion} value={opcion}>{opcion}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {BotonVistaPreviaFormularioJustificacion}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}> {BotonJustificacionAusencia} </Col>
                        </Row>
                        {
                            loading &&
                            <Cargando />
                        }
                        {
                            stateModalJustificacionES.url &&
                            <Row>
                                <Col xs={12}>
                                    <PDFViewer url={stateModalJustificacionES.url} heightValue={"100%"} />

                                </Col>
                            </Row>
                        }

                    </div>

                </>

            return tabla;
        }
    }, [stateModalJustificacionES, selectMarcacion, selectMotivo, horaDesde, horaHasta, errorHoras, fechaPermisoHora, loading, inputHoraHasta, horarioParaPermisoHora])

    function ReiniciarJustificacionES() {
        setstateModalJustificacionES({ tabladetalle: undefined, loadingInformacion: false, fecha: "", entrada: "", salida: "", tipo: "", exceso: "", url: "", tipojornada: "A" });
        setselectMarcacion("def");
        setselectMotivo("def");
        setfechaPermisoHora(null);
        setHoraDesde("");
        setHoraHasta("");
        seterrorHoras("");
    }

    async function verJutificacionES(fecha: string, entradaa: string, salidaa: string, tipo: string, exceso: string) {
        var nuevafecha = new Date();
        if (entradaa != null)
            nuevafecha.setHours(Number(entradaa.split(":")[0]), Number(entradaa.split(":")[1]), 0);
        else
            nuevafecha.setHours(12, 0, 0);
        var fecha2 = AgregarHoraAFecha(nuevafecha, "0:29");

        if (tipo === "A") {
            if (entradaa != null) {
                var horaentrada = entradaa.split(":")[0] + ":" + entradaa.split(":")[1];
                var [hora_desde, minuto_desde] = horaentrada.split(":");
                var fechaEscogida = new Date();
                fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +TIEMPO_MAX_ALMUERZO, 0);
                var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
                setHoraDesde(horaentrada);
                setHoraHasta(horahasta);
            }
            else if (salidaa !== null) {
                var horasalida = salidaa.split(":")[0] + ":" + salidaa.split(":")[1];
                var [hora_hasta, minuto_hasta] = horasalida.split(":");
                var fechaEscogida = new Date();
                fechaEscogida.setHours(Number(hora_hasta), Number(minuto_hasta) - +TIEMPO_MAX_ALMUERZO, 0);
                var horadesde = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
                setHoraDesde(horadesde);
                setHoraHasta(horasalida);
            }



            if (entradaa == null && salidaa != null) {
                setselectMarcacion(OPCIONES_SELECT_MARCACION[0]);
                setHoraHasta(salidaa)
            }
            else if (entradaa != null && salidaa == null)
                setselectMarcacion(OPCIONES_SELECT_MARCACION[1]);
            else if (entradaa == null && salidaa == null)
                setselectMarcacion(OPCIONES_SELECT_MARCACION[2]);
        }
        if (tipo === "E") {
            // var horadesde = datosMarcacion.marcacion_horario.horasalidal.split(":")[0] + ":" + datosMarcacion.marcacion_horario.horasalidal.split(":")[1];
            // var fechaEscogida = new Date();
            // var tiempoAlmuerzo = exceso.split(':');
            // var tiempoAlmuerzoMinutos = (+tiempoAlmuerzo[0]) * 60 + (+tiempoAlmuerzo[1]);
            // var [hora_desde, minuto_desde] = horadesde.split(":");
            // fechaEscogida.setHours(Number(hora_desde), Number(minuto_desde) + +tiempoAlmuerzoMinutos, 0);
            // var horahasta = fechaEscogida.getHours() + ":" + fechaEscogida.getMinutes();
            setexcesoMarcacion(exceso)

            // setHoraDesde(horadesde);
            // setHoraHasta(horahasta);
        }

        setstateModalJustificacionES({ ...stateModalJustificacionES, loadingInformacion: true, fecha: fecha, entrada: entradaa, salida: salidaa, tipo: tipo, exceso: exceso })
        //setstateModalDetalleES({ tabladetalle: undefined, loadingInformacion: false, fecha: "" })
        setstateModalJustificacionES({ tabladetalle: undefined, loadingInformacion: false, fecha: fecha, entrada: entradaa, salida: fecha2.toLocaleTimeString(), tipo: tipo, exceso: exceso, url: "", tipojornada: "A" })
    }

    const contenidoModalDetalleES: any = useMemo(() => {

        var fechaActual = new Date();
        fechaActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), 0, 0);
        // fechaActual = new Date(2024, 0, 31, 0, 0);

        if (stateModalDetalleES.loadingInformacion) {
            return <Cargando />
        }
        else if (stateModalDetalleES.tabladetalle !== undefined && stateModalDetalleES.tabladetalle.length === 0) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle</p>
                </>
            )
        }
        else if (stateModalDetalleES.tabladetalle !== undefined && stateModalDetalleES.loadingInformacion === false) {
            const datosUsuario = authenticationService.currentUserValue.token;
            const tabla =

                <div className="table-responsive containertablaDetalleMarcaciones">
                    <Table bordered className="tableMarcacionesDetalle tableHistorialSolicitudesVacaciones" >
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="" >
                                <th> Fecha</th>
                                <th> Hora inicio</th>
                                <th> Hora fin</th>
                                <th> Duración</th>
                                <th> Estado</th>
                                <th> Acciones</th>
                                <th> Estado solicitud</th>
                                <th> Documento</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                stateModalDetalleES.tabladetalle.map((infoDetalle, indinfoHist) => {
                                    // const mensajeExpiracionViene = infoDetalle.fechaVencimiento && infoDetalle.estadosolicituda !== "A" && infoDetalle.estadosolicituda !== "J" && infoDetalle.estadosolicituda !== "V" ;
                                    // const mensajeSolicitudExpiro = infoDetalle.fechaVencimiento && infoDetalle.cantidadSolicitudesVencidas < 2  && infoDetalle.estadosolicituda === "V" && fechaActual.getTime() > new Date(infoDetalle.fechaVencimiento).getTime()

                                    const fechaVencimientoLaboral = ""  // infoDetalle.fechaVencimientol ? ObtenerFechaLaboralDeSuma(infoDetalle.fechaVencimientol, 1, datosMarcacion.feriados).toISOString() : undefined;
                                    const fechaVencimientoReceso = ""  // infoDetalle.fechaVencimientoa ? ObtenerFechaLaboralDeSuma(infoDetalle.fechaVencimientoa, 1, datosMarcacion.feriados).toISOString() : undefined;
                                    const fechaVencimientoRecesoDate = ""  // infoDetalle.fechaVencimientoa ? ObtenerFechaLaboralDeSuma(infoDetalle.fechaVencimientoa, 1, datosMarcacion.feriados) : undefined;

                                    const disableCheck = true //(infoDetalle.justificara !== "E" && infoDetalle.justificara !== "A") || infoDetalle.fechaPlazoSolicituda !== undefined && infoDetalle.fechaPlazoSolicituda !== null && fechaActual.getTime() > new Date(infoDetalle.fechaPlazoSolicituda).getTime() || (fechaVencimientoRecesoDate !== undefined && fechaVencimientoRecesoDate !== null && fechaActual.getTime() > fechaVencimientoRecesoDate.getTime());

                                    const classNameEstadoNovedadA: string = ESTADOS_CON_NOVEDAD.includes(infoDetalle.estadoa) ? "estadoNovedadMarcacion" : "";

                                    var filasEstadosDetalleEntradaSalida = <div></div>
                                    if (infoDetalle.finSemanaFeriado) {
                                        filasEstadosDetalleEntradaSalida = (
                                            <td colSpan={7}>
                                                <div className="small-error">
                                                    {"FIN DE SEMANA/FERIADO"}
                                                </div>
                                            </td>
                                        )
                                    }
                                    else {
                                        filasEstadosDetalleEntradaSalida = (
                                            <React.Fragment>
                                                <td >
                                                    <div className={classNameEstadoNovedadA}>
                                                        {infoDetalle.estadoa}
                                                    </div>
                                                </td>
                                                <td>
                                                    {(infoDetalle.justificara == "E" || infoDetalle.justificara == "A") ?
                                                        <>
                                                            <input type="checkbox" defaultValue="A" readOnly disabled={disableCheck} checked={infoDetalle.mensajea != null ? true : false} onClick={() => verJutificacionES(infoDetalle.fecha, infoDetalle.entradaa, infoDetalle.salidaa, infoDetalle.justificara, infoDetalle.excesoa)}></input>
                                                            {infoDetalle.mensajea != null ? infoDetalle.mensajea : ""}
                                                        </>
                                                        :
                                                        <>
                                                            {/* {infoDetalle.mensajea != null ? infoDetalle.mensajea : ""} */}
                                                        </>}
                                                </td>
                                                <td>

                                                    <div>{infoDetalle.estadosolicitudnombrea}</div>
                                                    {
                                                        infoDetalle.fechaPlazoSolicituda && fechaActual.getTime() <= new Date(infoDetalle.fechaPlazoSolicituda).getTime() &&
                                                        <small className='small-error-big'>
                                                            {"Puede realizar una solicitud hasta el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaPlazoSolicituda.toString())}
                                                        </small>
                                                    }
                                                    {
                                                        infoDetalle.fechaPlazoSolicituda && fechaActual.getTime() > new Date(infoDetalle.fechaPlazoSolicituda).getTime() &&
                                                        <small className='small-error-big'>
                                                            {"El plazo para solicitar venció"}
                                                        </small>
                                                    }

                                                    {
                                                        infoDetalle.fechaVencimientoa && ValidarMensajeExpiracionProxima(infoDetalle, "A") &&
                                                        <TdSeeMoreContent
                                                            text={"Su solicitud caduca el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientoa.toString()) + ". Gestione su aprobación con su directivo"}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        !infoDetalle.fechaVencimientoRecuperaciona && infoDetalle.fechaVencimientoa && ValidarMensajeSolicitudExpirada(infoDetalle, "A", fechaActual) &&
                                                        <TdSeeMoreContent
                                                            text={"Su solicitud caducó el " + ObtenerFechaFromIsoFormat(infoDetalle.fechaVencimientoa.toString()) + ". Puede solicitar 1 vez más hasta el " + ObtenerFechaFromIsoFormat(fechaVencimientoReceso)}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        infoDetalle.fechaVencimientoRecuperaciona && fechaVencimientoRecesoDate && ValidarMensajeSolicitudRecuperacionNoEjecutada(infoDetalle, "A", fechaActual, fechaVencimientoRecesoDate) &&
                                                        <TdSeeMoreContent
                                                            text={"Esta recuperación NO fue ejecutada. Puede solicitar 1 vez más hasta el " + ObtenerFechaFromIsoFormat(fechaVencimientoReceso)}
                                                            lengthToSee={60}
                                                        />
                                                    }
                                                    {
                                                        infoDetalle.fechaVencimientoRecuperaciona && fechaVencimientoRecesoDate && ValidarMensajeSolicitudRecuperacionNoEjecutadaVencida(infoDetalle, "A", fechaActual, fechaVencimientoRecesoDate) &&
                                                        <TdSeeMoreContent
                                                            text={"Esta recuperación NO fue ejecutada. El plazo para solicitar VENCIÓ el " + ObtenerFechaFromIsoFormat(fechaVencimientoReceso)}
                                                            lengthToSee={60}
                                                        />
                                                    }


                                                </td>
                                                <td>
                                                    {
                                                        (infoDetalle.estadosolicituda === "J" || infoDetalle.estadosolicituda === "O" || infoDetalle.estadosolicituda === "A") &&
                                                        <div className="align-self-center">
                                                            <i className="fas fa-file-pdf opcion_formulario_pdf "
                                                                onClick={() => DownloadDocument(infoDetalle.referenciaa, datosUsuario, "formulario")}
                                                                data-toggle="tooltip" data-placement="top" title="Descargar formulario"
                                                            >

                                                            </i>
                                                        </div>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        )
                                    }


                                    return (
                                        <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleES " + indinfoHist}>
                                            <td>
                                                {infoDetalle.fecha}
                                            </td>
                                            <td>
                                                {infoDetalle.entradaa}
                                            </td>
                                            <td>
                                                {infoDetalle.salidaa}
                                            </td>
                                            <td>
                                                {infoDetalle.duraciona}
                                            </td>
                                            {
                                                filasEstadosDetalleEntradaSalida
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                </div>
            return tabla;
        }
        //}, [stateModalDetalleES, datosMarcacion.feriados])
    }, [stateModalDetalleES])

    async function verDetalleES(fecha: string) {
        setstateModalDetalleES({ ...stateModalDetalleES, loadingInformacion: true, fecha: fecha })
        const respuestaRequestDetalle = await obtenerDetalleES(fecha);
        if (respuestaRequestDetalle.status !== 200 || respuestaRequestDetalle.dataResponse === undefined) {
            setstateModalDetalleES({ ...stateModalDetalleES, loadingInformacion: false });
            alertService.error(respuestaRequestDetalle.errorMessage ?? "Ha ocurrido un inconveniente al intentar obtener la información.");
        } else {
            const data = respuestaRequestDetalle.dataResponse;
            setstateModalDetalleES({ tabladetalle: data.tabladetalle, loadingInformacion: false, fecha: fecha });
        }
    }

    async function GetInfoMarcacion() {
        setloadingDatos(true)
        var userData: UserData = authenticationService.currentUserValue;
        const URL = `${configData.SERVER_URL}RegistroEntradaSalida/InformacionGeneral`;

        try {
            const respuesta = await axios.get(URL, {
                headers: authHeaderWithToken(userData.token),
            })

            var datos: InformacionGeneral = respuesta.data;
            if (respuesta.data.strEstado === "N")
                showAlertAviso(respuesta.data.strMensaje)
            else
                setdatosMarcacion(datos);

            if (datos && (!datos.marcacion_dia.entradal || datos.marcacion_dia.entradal === null)) {
                showAlertAviso("Ud. no posee marcación o justificación de su entrada de labores, por favor, gestione su marcación")
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                ;
            }
            handleError();
        }

        setloadingDatos(false);
    }

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //getIp();
        //GetInfoMarcacion();

        //const infoModalMarcacion = localStorage.getItem(KEY_SHOWMODAL_MARCACION_AVISO);
        //if (infoModalMarcacion === null) {
        //    CreateLocalStorageMensajeMarcacion()
        //    setmostrarModalMarcacion(true);
        //}
        //else {
        //    const showInformacion = VerifyShowMensajeMarcacionStorage();
        //    setmostrarModalMarcacion(showInformacion)

        //}



    }, [])
    useEffect(() => {
        if (datosMarcacion && datosMarcacion.marcacion_horario && datosMarcacion.marcacion_horario.fecha) {
            verDetalleES(datosMarcacion.marcacion_horario.fecha);
        }
    }, [datosMarcacion.marcacion_horario.fecha]);  // Asegúrate de que esta es la dependencia correcta

    useEffect(() => {
        //var timer = setInterval(() => setDate(new Date()), 1000)
        var serverTime = new Date(Number(datosMarcacion.marcacion_horario.fechahora));
        var localTime = new Date();
        var timeDiff = serverTime.getTime() - localTime.getTime();

        var timer = setInterval(() => setDate(new Date((new Date().getTime() + timeDiff))), 1000);

        return function cleanup() {
            clearInterval(timer)
        }
    }, [datosMarcacion]);

    const contenidoMensajeAlerta = (
        <div>
            {"El rango de horas para el receso/almuerzo es desde las 12h00 hasta las 15h00. La duración del receso/almuerzo es de 30 minutos."}
        </div>
    )






    const contenidoModalImagen = (
        <div style={{ textAlign: "center" }}>
            <img className={"containerBanner"}
                src={COMUNICADOMARCACION} alt="comunicadoMarcacion"></img>
        </div>

    )





    if (loadingDatos) {
        return <Cargando />
    }





    return (
        <div className="content">
            <h3 className="title">Marcaciones de Receso/Almuerzo</h3>
            <h5 className="title">Registro de marcaciones de inicio/fin al receso/almuerzo</h5>


            <Row className="">
                <Col >
                    <AlertNew
                        cabeceraTitulo={"¡¡ADVERTENCIA!!"}
                        mensaje={MENSAJE_ADVERTENCIA_LAPSO_SOLICITUD}
                        tipo={TiposAlerta.ADVERTENCIA}
                        oncloseElement={() => { }}
                    />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col >
                    <AlertNew
                        cabeceraTitulo={"Para su conocimiento"}
                        mensaje={" "}
                        tipo={TiposAlerta.PARA_CONOCIMIENTO}
                        mensajeHTML={contenidoMensajeAlerta}
                        oncloseElement={() => { }}
                    />
                </Col>
            </Row>



            <Row>
                <Col >
                    <Card>
                        <CardHeader className="blanco text-center" style={{ backgroundColor: "#00A6E0" }}>
                            {"Registre su hora de inicio/fin al receso/almuerzo"}
                        </CardHeader>
                        <CardBody>

                            <div style={{ textAlign: "center" }}>
                                <h5 style={{ marginBottom: 0, color: "#6c757d" }}>
                                    <i className="fa-regular fa-calendar" style={{ marginRight: "10px" }}></i>
                                    Fecha: {date.toLocaleDateString()}
                                </h5>
                                <h6 style={{ color: "#343a40" }}>
                                    <i className="fa-regular fa-clock" style={{ marginRight: "10px" }}></i>
                                    Hora: {date.toLocaleTimeString()}
                                </h6>
                            </div>


                            {
                                loading && <Cargando />
                            }
                            {
                                !loading &&
                                <>
                                    <Row>
                                        <Col md={6} xl={6} xs={6}> {BotonGenerarRegistrarMarcacionE} </Col>
                                        <Col md={6} xl={6} xs={6}> {BotonGenerarRegistrarMarcacionS} </Col>
                                    </Row>
                                    {/* Aquí se integra la tabla de registros de receso/almuerzo */}
                                    <Table bordered className="table_planificacion_vacaciones">
                                        <thead className="cabeceras_tabla_planificacion_vac">
                                            <tr>
                                                <th colSpan={1}>{"Hora inicio"}</th>
                                                <th colSpan={1}>{"Hora fin"}</th>
                                                <th colSpan={1}>{"Duración"}</th>
                                                <th colSpan={1}>{"Estado"}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                <tr className="rows_tabla_planificacion_vac_directivo"  >
                                                    <td>
                                                        {datosMarcacion.marcacion_dia.entradaa}
                                                    </td>
                                                    <td>
                                                        {datosMarcacion.marcacion_dia.salidaa}
                                                    </td>
                                                    <td>
                                                        {datosMarcacion.marcacion_dia.duraciona}
                                                    </td>
                                                    <td>
                                                        {datosMarcacion.marcacion_dia.estadoa}
                                                    </td>
                                                </tr>
                                            }
                                            {/* {
                                                datosMarcacion.lista_registro.map((l_marcacion, i_l_marcacion) => {
                                                    const classNameEstadoNovedadA: string = ESTADOS_CON_NOVEDAD.includes(l_marcacion.estadoa) ? "estadoNovedadMarcacion" : "";
                                                    return (
                                                        <tr className="rows_tabla_planificacion_vac_directivo" key={i_l_marcacion} >
                                                            <td>
                                                                {l_marcacion.entradaa}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.salidaa}
                                                            </td>
                                                            <td>
                                                                {l_marcacion.duraciona}
                                                            </td>
                                                            <td>
                                                                <div className={classNameEstadoNovedadA}>
                                                                    {l_marcacion.estadoa}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            } */}
                                        </tbody>
                                    </Table>

                                    <Row>
                                        <Col>
                                            {/*<Link to="https://th.espol.edu.ec/user/informacion-laboral/marcaciones" style={{ textDecoration: 'underline', color: 'blue' }}>*/}
                                            {/*    Ver historial de marcaciones / Ingreso de justificaciones*/}
                                            {/*</Link>*/}
                                            <a
                                                href="https://th.espol.edu.ec/user/informacion-laboral/marcaciones"
                                                style={{ textDecoration: 'underline', color: 'blue' }}
                                            >
                                                Ver historial de marcaciones / Ingreso de justificaciones
                                            </a>
                                        </Col>
                                    </Row>
                                </>
                            }
                        </CardBody>
                    </Card>
                </Col>
            </Row>





        </div>
    )
}